import { render, staticRenderFns } from "./ecMarquee.vue?vue&type=template&id=0cdcd4bf&scoped=true&lang=pug"
import script from "./ecMarquee.vue?vue&type=script&lang=ts"
export * from "./ecMarquee.vue?vue&type=script&lang=ts"
import style0 from "./ecMarquee.vue?vue&type=style&index=0&id=0cdcd4bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdcd4bf",
  null
  
)

export default component.exports